import React, { useEffect, useState, useContext } from "react";
import { BotaoMenor, Spinner } from "../../StyledComponent";
import Unread from "../../../assets/mark_as_unread-24px.png";
import { Context } from "../../../services/auth";
import TrocaSenhaPrimeiroAcesso from "../TrocaSenhaPrimeiroAcesso";
import MsgResendCode from "../MsgSendNewCode";
import Fade from "@material-ui/core/Fade";
import { useHistory } from "react-router-dom";
import "./styles.scss";

const CPFFound = ({ cpf, userEmail }) => {
  const [verifyCode, setVerifyCode] = useState("");

  const [showTrocaSenha, setShowTrocaSenha] = useState(false);
  const [userEmailMasked, setUserEmailMasked] = useState("");
  const [msgErro, setMsgErro] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendCode, setResendCode] = useState(false);

  const { confirmSignUPDeleteUser } = useContext(Context);

  const history = useHistory();

  useEffect(() => {
    maskEmail();
  }, []);

  useEffect(() => {
    setMsgErro("");
  }, [verifyCode]);

  function maskEmail() {
    if (userEmail) {
      var maskedEmail = userEmail?.split("@");

      let tamanho = maskedEmail[0]?.split("");
      let toMask = maskedEmail[0]?.slice(1, tamanho.length - 1);

      let newStr = toMask?.replace(/[a-z0-9]/gi, "*");

      let lastCharacter = tamanho.length - 1;

      setUserEmailMasked(
        tamanho[0] + newStr + tamanho[lastCharacter] + "@" + maskedEmail[1]
      );
    }
  }

  async function confirmaUsuario(event) {
    event.preventDefault();

    setLoading(true);

    let resultSignUp = "";

    try {
      resultSignUp = await confirmSignUPDeleteUser(userEmail, verifyCode, cpf);

      setLoading(false);
      setVerifyCode("");
      if (resultSignUp === undefined) {
        setShowTrocaSenha(true);
      } else if (resultSignUp.code === "CodeMismatchException") {
        setLoading(false);
        setMsgErro("Código incorreto");
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  if (!userEmail) history.push("/");

  return (
    <>
      {resendCode ? (
        <MsgResendCode email={userEmail} />
      ) : (
        <>
          {showTrocaSenha ? (
            <TrocaSenhaPrimeiroAcesso
              userEmail={userEmail}
              verifyCode={verifyCode}
              cpf={cpf}
            />
          ) : (
            <Fade in>
              <div className="loginForm loginForgotPassword">
                <div className="first-access-email centralized-column">
                  <h1 className="first-access-email__title centralized-column">
                    <span className="first-access-email__title__firstAccess">
                      Primeiro Acesso:
                    </span>
                    <div className="centralized first-access-email__title__information">
                      {/* <ReactSVG src={Unread} /> */}
                      <img src={Unread} />
                      <span>Autenticação em dois fatores</span>
                    </div>
                  </h1>
                  <p>
                    Enviamos um código de verificação para o e-mail cadastrado:
                  </p>
                  <p className="first-access-email__email">{userEmailMasked}</p>
                  <form
                    onSubmit={(event) => {
                      confirmaUsuario(event);
                    }}
                    className="centralized-column"
                  >
                    <input
                      id="txtVerifyCode"
                      inputMode="numeric"
                      placeholder="código"
                      maxLength="6"
                      autoComplete="off"
                      onChange={(event) => {
                        setVerifyCode(event.target.value);
                      }}
                    />
                    {loading ? (
                      <Spinner />
                    ) : (
                      <BotaoMenor
                        disabled={verifyCode.length < 6 ? true : false}
                        color="#ffffff"
                        id="btnConfirmCode"
                        backgroundcolor="#003DA5"
                        type="submit"
                      >
                        {msgErro != "" && <span>{msgErro}</span>}

                        {!msgErro != "" && <span>CONFIRMAR</span>}
                      </BotaoMenor>
                    )}
                    <button
                      className="first-access-email__resendCode"
                      id="btnNewCode"
                      onClick={(event) => {
                        setResendCode(true);
                        event.preventDefault();
                      }}
                    >
                      Não recebeu um código?
                    </button>
                  </form>
                </div>
              </div>
            </Fade>
          )}
        </>
      )}
    </>
  );
};

export default CPFFound;
